import { InputProps } from "@chakra-ui/react"
import { Input } from "@chakra-ui/react";
import { forwardRef } from "react";

const WhiteBgInput = forwardRef<HTMLInputElement, InputProps>((props, ref = null) => {
  return (
    <Input 
      backgroundColor={"white"}
      borderRadius={"md"}
      ref={ref}
      {...props}
    />
  )
});

WhiteBgInput.displayName = 'WhiteBgInput';

export default WhiteBgInput;